import AuthApi from "../utils/api/AuthApi";
import useAuthToken from "./useAuthToken";
import {useMemo} from "react";

export default function useAuthApi() {
    const {auth_token} = useAuthToken()

    // returns same cached instance of AuthApi as long as token value is same
    return useMemo(()=>{
        return new AuthApi(auth_token)
    }, [auth_token])
}
